<template>
  <div>
    <b-tabs content-class="" fill v-model="tabIndex">
      <b-tab ref="item" data-key="item" :title="$t('item')">
        <SettingsItem />
      </b-tab>
      <b-tab ref="sales" data-key="sales" :title="$t('sales')">
        <SettingsSales />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import SettingsItem from './SettingsItem.vue';
import SettingsSales from './SettingsSales.vue';

export default {
  name: 'Settings',
  components: {
    SettingsItem,
    SettingsSales,
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
};
</script>

<style scoped>
/* Component styles */
</style>
